<template>
  <div class="cb-baseSignInWelcomePanel hideMobile">
    <div class="container">
      <div class="inner">
        <div class="image">
          <slot name="image"> </slot>
        </div>
        <div class="text">
          <p class="preamble">
            <slot name="header"></slot>
            <slot name="subHeader"></slot>
            <slot name="content"></slot>
            <slot name="buttons">
              <BasePrimaryButton @click.native="$emit('sign-in')">
                {{ signInButtonText }}
              </BasePrimaryButton>
              <BaseSecondaryButton @click.native="$emit('no-sign-in')">
                {{ noSignInButtonText }}
              </BaseSecondaryButton>
            </slot>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePrimaryButton from "@web-components/components/BasePrimaryButton";
import BaseSecondaryButton from "@web-components/components/BaseSecondaryButton";
export default {
  components: {
    BasePrimaryButton,
    BaseSecondaryButton,
  },
  props: {
    signInButtonText: {
      type: String,
      required: true,
    },
    noSignInButtonText: {
      type: String,
      required: true,
    },
  },
  inheritAttrs: false,
};
</script>

<style lang="scss">
@import "~@web-components/scss/components/_baseSignInWelcomePanel.scss";
</style>
